module.exports = __webpack_public_path__ + "img/sort-alpha-down.9f700f39.svg";